import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DataTable, {
      value: _ctx.pages,
      class: "p-datatable-sm",
      stripedRows: "",
      resizableColumns: true,
      columnResizeMode: "fit",
      showGridlines: "",
      responsiveLayout: "scroll",
      scrollHeight: "80vh",
      paginator: true,
      rowsPerPageOptions: [5, 20, 50, 100],
      rows: 50,
      lazy: true,
      totalRecords: _ctx.total,
      loading: _ctx.isLoading,
      onSort: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onFilter($event))),
      onFilter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onFilter($event))),
      onPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFilter($event))),
      filterDisplay: "row",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "slug",
          header: "Slug",
          sortable: true,
          "show-filter-menu": false,
          "show-clear-button": true
        }, {
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
              class: "p-column-filter",
              placeholder: "Slug"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "titleDe",
          header: "Titel DE",
          sortable: true,
          "show-filter-menu": false,
          "show-clear-button": true
        }, {
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
              class: "p-column-filter",
              placeholder: "Titel DE"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "titleEn",
          header: "Titel EN",
          sortable: true,
          "show-filter-menu": false,
          "show-clear-button": true
        }, {
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
              class: "p-column-filter",
              placeholder: "Titel EN"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { style: {"width":"150px"} }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_Button, {
                class: "p-button-raised p-button-rounded p-button-info",
                icon: "pi pi-refresh",
                onClick: _ctx.refresh
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addPage())),
                class: "p-button-raised p-button-rounded p-button-info ml-1",
                icon: "pi pi-plus",
                iconPos: "right"
              })
            ])
          ]),
          body: _withCtx((slotProps) => [
            _createVNode(_component_Button, {
              onClick: ($event: any) => (_ctx.editPage(slotProps.data)),
              class: "p-button-raised p-button-rounded",
              icon: "pi pi-pencil",
              iconPos: "right"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              class: "p-button-raised p-button-rounded p-button-danger ml-1",
              icon: "pi pi-trash",
              iconPos: "right",
              onClick: ($event: any) => (_ctx.deletePage($event, slotProps.data))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "totalRecords", "loading", "filters"]),
    _createVNode(_component_ConfirmPopup)
  ]))
}